<div class="MainBg">
    <div class="NewHeadOuter">
        <div>
            <div class="SectionTopHeading_n">Tally Sheet</div>
            <div class="SubHeader"></div>
        </div>
    </div>
    <div class="MainInnerFormWithoutFlex">
        <div class="FormTemplate pb-0">
          <div class="row">
            <div  class="col-lg-3 col-md-4 col-sm-6 col-xs-12 InputBoxOuter">
              <div class="has-float-label">
                <select
                  class="form-control CommonSelectBox TbxMarginBtm CustomSelectCompany"
                  id="CompanyId"
                >
                  <option value="">Select Company</option>
                  <option
                    *ngFor="let item of CompanyList"
                    value="{{ item.VALUEFIELD }}"
                  >
                  {{item.TEXTFIELD}}
                  </option>
                </select>
                <label>Company Name</label>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12 InputBoxOuter" >
              <div class="has-float-label">
                <input
                  type="text"
                  class="form-control CommonTextBox TbxMarginBtm"
                  id="ApplicationNo"
                  placeholder="&nbsp;"
                />
                <label for="ApplicationNo">Application No</label>

              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-3 col-xs-12 InputBoxOuter">
              <button id="download" class="CommonSubmitButton" (click)="BindTallySheetList('0','ApplicationNo')">Search</button>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12 InputBoxOuter">
              <button id="download" class="CommonSubmitButton btn-sm" (click)="downloadTallySheet('0','New')">Download Tally Sheet</button>
            </div>
          </div>
        </div>
      </div>



    <!-- code for pdf  -->
    <div class="MainInnerFormWithoutFlex border-none d-none">
        <div class="row">
            <div class="col-md-12">
                <div class="card" id="invoice">
                    <div class=" card-header bg-transparent header-elements-inline">
                        <p class="card-title  d-flex justify-content-center"><u>Internal Tally Sheet - Bond</u></p>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="mb-4 pull-left">
                                    <p>Date:- <span class="font-weight-semibold">{{today | date:'dd-MM-yyyy'}}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="mb-4 pull-left">
                                    <p>REF:- <span class="font-weight-semibold">{{CompanyName}}</span></p>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table id="dataTable_tally_sheet_pdf" class="CommonTable ClsReportTable nowrap table-sm"
                                width="100%">
                                <thead>
                                    <tr>
                                        <th>Ref No.</th>
                                        <th>Application No.</th>
                                        <th colspan="3">Client ID/Client Name</th>
                                        <th>PAN</th>
                                        <th class="text-right">Quantity</th>
                                        <th class="text-right">Price</th>
                                        <th class="text-right">Amount</th>
                                        <th>Bank Name</th>
                                        <th class="text-right">Series</th>
                                        <th class="text-right">Sub Category</th>
                                        <th class="text-right">Sub Broker</th>
                                        <th class="text-right">Exchnage No.</th>
                                        <th>UPI ID</th>
                                        <th>Bank A/C No.</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let data of tallysheet;let i = index">
                                        <td>{{i + 1}}</td>
                                        <td>{{data.ApplicationNo}}</td>
                                        <td colspan="3">{{data.ClientDematId}}</td>
                                        <td>{{data.PAN}}</td>
                                        <td class="text-right">{{data.Quantity}}</td>
                                        <td class="text-right">{{data.Price}}</td>
                                        <td class="text-right">{{data.Amount}}</td>
                                        <td>{{data.BankName}}</td>
                                        <td class="text-right">{{data.Series}}</td>
                                        <td class="text-right">{{data.Category}}</td>
                                        <td class="text-right">{{data.SubBrokerCode}}</td>
                                        <td class="text-right">{{data.BidId}}</td>
                                        <td>{{data.UPIId}}</td>
                                        <td>{{data.BankAccountNo}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="d-md-flex flex-md-wrap">
                            <div class="pt-2 mb-3 wmin-md-400 ml-auto">
                                <div class="table-responsive">
                                    <table class="table table-bordered table-sm">
                                        <tbody>
                                            <tr>
                                                <td class="text-left pb-0">
                                                    <p class="mb-3 text-left">Total Amount</p>
                                                </td>
                                                <td class="text-right">
                                                    <b>{{TotalApplicationAmount}}</b>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <!-- <div class="text-right mt-3"> <button type="button" class="btn btn-primary"><b><i
                                            class="fa fa-paper-plane-o mr-1"></i></b>
                                    Send invoice</button> </div> -->
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-6 text-left">
                                <div class="mb-4 pull-left break-col">
                                    <p>Total Count of Applications: &nbsp;<span
                                            class="font-weight-semibold"><b>{{TotalApplicationCount}}</b></span></p>
                                    <p>Total Count of Applications Rejected: &nbsp;<span
                                            class="font-weight-semibold"><b>{{TotalApplicationRejected}}</b></span></p>
                                    <p>Total Applications Delivered: &nbsp;<span
                                            class="font-weight-semibold"><b>{{TotalApplicationCount}}</b></span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-6"></div>
                            <div class="col-sm-6 text-left d-flex justify-content-around">
                                <div class="mb-4  break-col">
                                    <p>Received by Bank</p>
                                    <p>Bank Seal</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- table start-->
    <div id="TblReportSection" class="MainInnerFormWithoutFlex">
        <div class="tab-content DotTabsContent">
            <div class="tab-pane active show">
                <div class="table-responsive table-container">
                    <table id="dataTable_tally_sheet" class="CommonTable ClsReportTable nowrap" width="100%">
                        <thead>
                            <tr>
                                <th>Sr No.</th>
                                <th>File Name</th>
                                <th>Generated Date</th>
                                <th class="text-right">Download PDF</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of tallySheetList; let i= index">
                                <td>{{i+1}}</td>
                                <td>{{item.FileName}}</td>
                                <td>{{item.GeneratedDate}}</td>
                                <td>
                                    <span class="d-flex justify-content-end">
                                        <button class="BtnCommon BtnRed BtnExport ml-2 text-right"
                                            (click)="downloadTallySheet(item.LotNo,'ByLotNo')">
                                            <img src="../../assets/images/PDF_Export.svg" class="ExportToIcon"
                                                type="image/svg+xml" fill="#fff" width="12px"
                                                pluginspage="http://www.adobe.com/svg/viewer/install/" /></button>
                                    </span>
                                </td>

                            </tr>
                        </tbody>

                    </table>
                </div>
            </div>
        </div>
    </div>

</div>

<!-- <div class="modal" id="AlertModal" appDisabledRightClick>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content AlertModalContentCls">
      <div class="modal-header AlertModalHeader">Important Message</div>
      <div id="AlertModalContent1" class="modal-body AlertModalBody"></div>
      <div class="modal-footer AlertModalFooter">
        <button type="button" data-dismiss="modal" class="CursorPointer">Okay</button>
      </div>
    </div>
  </div>
</div> -->
